import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }


  interface Props {
    modelValue: any;
  }
  
import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: "HText",
  
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: "HTEXT_DEFAULT_VALUE" }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.modelValue !== 'HTEXT_DEFAULT_VALUE')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!!_ctx.modelValue || _ctx.modelValue === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.modelValue), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, "--"))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})